import { render, staticRenderFns } from "./ProviderComponentTable.vue?vue&type=template&id=4e229774&scoped=true"
import script from "./ProviderComponentTable.vue?vue&type=script&lang=js"
export * from "./ProviderComponentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e229774",
  null
  
)

export default component.exports